import api from './api'

export async function createOrder(data) {
  const { data: res } = await api.post('/orders', data)
  return res
}

export async function getOrder(id) {
  const { data: res } = await api.get(`/orders/${encodeURIComponent(id)}`)
  return res
}
